module.exports = __webpack_public_path__ + "img/10.6c1f152f.png";